import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinnerThird } from "@fortawesome/pro-duotone-svg-icons";
import styled, { css } from "styled-components";
import { FlexRow } from 'app-styled/flex';
import { Message } from "@localization";

const LoadingWrp = styled(FlexRow)`
  align-items: center;
  justify-content: center;
  span {
    font-size: 20px;
  }
`;

const IconWrap = styled.div`
  padding-right: 10px;
  svg {
    font-size: 28px;
  }
`;

const Loading = () => {
  return (
    <LoadingWrp>
      <IconWrap>
        <FontAwesomeIcon icon={faSpinnerThird} className={"fa-spin"} />
      </IconWrap>
      <Message messageKey={"loading"} defaultMessage={"Loading"} />
    </LoadingWrp>
  );
};

export default Loading;
